export default __webpack_public_path__ + "static/media/banco-de-chile.5df20d26.svg";